/**
 * 게시판 목록(이벤트·공지·FAQ) 쿼리 키와 서버 프리페치. 블로그는 lib/blog-list.ts 를 쓴다.
 * 서버 프리페치(page.tsx)와 클라이언트 훅(article.query.ts useArticleList)이 같은 키를 써야
 * 하이드레이션이 맞물린다. 어긋나면 곧바로 다시 요청해 서버가 실은 목록이 버려진다.
 *
 * 목록을 서버에서 받아 두지 않으면 크롤러가 받는 HTML에 목록이 없다.
 * 구글은 렌더링으로 복구하지만 네이버는 JS 렌더링이 제한적이다.
 */
import { getArticleList } from '@/services/article.service';
import { QUERY_KEYS } from '@/services/base-api';
import { GetArticleListParams } from '@/services/types/article.type';
import { QueryClient } from '@tanstack/react-query';

export function articleListQueryKey(params?: GetArticleListParams) {
  return [QUERY_KEYS.ARTICLE, QUERY_KEYS.LIST, params] as const;
}

/** 글 목록을 서버 쿼리 캐시에 넣는다. 실패하면 비워 두고 클라이언트가 다시 받는다. */
export function prefetchArticleList(
  queryClient: QueryClient,
  params: GetArticleListParams,
) {
  return queryClient.prefetchQuery({
    queryKey: articleListQueryKey(params),
    queryFn: () => getArticleList(params),
  });
}
